import { getRoutePreview, getRoutePreviewHopper, getRoutePreviewVRP } from "../actions/rmActions";

export const handleRoutePlanning = async(t, dispatch, reduced, warehouse, routeType, routePlanner) => {
    let params = {
        orders: reduced,
        warehouse: warehouse
    }
    if(routeType === 1 || (routePlanner.start && routePlanner.end)) {
        params['start'] = routePlanner.start;
        params['end'] = routePlanner.end;
    }
    if(routeType === 3) {
        return await dispatch(getRoutePreviewHopper(params))
    } else if(routeType === 2) {
        return await dispatch(getRoutePreviewVRP(params))
    } else {
        return await dispatch(getRoutePreview(params))
    }
}
